<template>
  <div id="modalEditField" v-if="visible">
    <div class="modalHeader">
      <span class="title">Edit Form Field</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>
    <div class="globalAlert" v-if="$store.state.currentTemplateName === 'global'">You are currently viewing the global template. The global template cannot be modified.</div>


    <div class="modalBody">
      <div class="row modal-section">
        <div class="col-sm-3">
          <div class="form-group">
            <label for="usr"><b>Field ID</b></label>
            <input type="text" class="form-control form-control-sm" readonly v-model="fieldData.id">
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group">
            <label for="usr"><b>Type</b></label>
            <select class="form-control form-control-sm" id="type" v-model="fieldData.type" :disabled="$store.state.currentTemplateName === 'global'">
              <option value="text">Text</option>
              <option value="checkbox">Checkbox</option>
              <option value="select">Dropdown</option>
            </select>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group" v-if="fieldData.type === 'select'">
            <label for="usr"><b>Dropdown Options (separate with | character)</b></label>
            <input type="text" class="form-control form-control-sm" v-model="choiceData" :disabled="$store.state.currentTemplateName === 'global'">
          </div>
          <div class="form-group" v-else>
            <label for="usr"><b>Input Mask</b></label>
            <select class="form-control form-control-sm" id="inputMask" v-model="fieldData.maskType" :disabled="$store.state.currentTemplateName === 'global' || fieldData.type !== 'text'">
              <option v-for="field in maskTypes" :key="field.maskType" :value="field.maskType" :selected="field.maskType === fieldData.maskType">
                {{ field.maskType }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group">
            <label for="usr"><b>Tab Index</b></label>
            <input type="number" min="-1" :class="['form-control form-control-sm', validTabIndex ? '' : 'invalid']" id="tabIndex" @change="validateTabIndex" v-model="fieldData.tabOrder" :disabled="$store.state.currentTemplateName === 'global'">
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="usr"><b>X Position</b></label>
            <input type="number" class="form-control form-control-sm" v-model="fieldData.x" :disabled="$store.state.currentTemplateName === 'global'">
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="usr"><b>Y Position</b></label>
            <input type="text" class="form-control form-control-sm" v-model="fieldData.y" :disabled="$store.state.currentTemplateName === 'global'">
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="usr"><b>Width</b></label>
            <input type="number" class="form-control form-control-sm" v-model="fieldData.width" :disabled="$store.state.currentTemplateName === 'global'">
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="usr"><b>Height</b></label>
            <input type="number" class="form-control form-control-sm" v-model="fieldData.height" :disabled="$store.state.currentTemplateName === 'global'">
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label style="width:30%;"><b>Field Group</b></label>
            <button class="btn btn-sm btn-success btnNewGroup" @click="createFieldGroup">New Group</button>
            <select v-if="Object.keys(fieldNames).length" class="form-control form-control-sm" v-model="fieldGroup" @change="changeGroup">
              <option value="none">None</option>
              <option v-for="(name, index) in fieldNames" :value="index" :key="index">{{ name }}</option>
            </select>
          </div>

          <div class="form-group" v-if="isCheckbox">
            <label style="width:30%;"><b>Checkbox Group</b></label>
            <button class="btn btn-sm btn-success btnNewGroup" @click="createCheckboxGroup">New Group</button>
            <select v-if="Object.keys(checkboxNames).length" class="form-control form-control-sm" v-model="checkboxGroup" @change="changeCheckboxGroup">
              <option value="none">None</option>
              <option v-for="(name, index) in checkboxNames" :value="index" :key="index">{{ name }}</option>
            </select>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="prefix"><b>Prefix</b></label>
            <input type="text" class="form-control form-control-sm" v-model="fieldData.prefix" :disabled="$store.state.currentTemplateName === 'global'">
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label for="model"><b>Model</b></label>
            <input
              id="txtFieldModel"
              type="text"
              class="form-control form-control-sm"
              v-model="fieldData.model"
              :disabled="$store.state.currentTemplateName === 'global'"
              @keyup="setAutocompleteModel"
              @blur="hideAutocompleteModel"
            >

            <autocomplete-model
              v-if="isAutocompleteModel === true && (this.fieldData.value === '' || this.fieldData.value === undefined || this.fieldData.value === null)"
              :data="autocompleteModelData"
              :model="autocompleteModel"
              @set-model-value="setModelValue"
            />
          </div>
        </div>

        <!-- VALUE -->

        <div class="col-sm-3">
          <div class="form-group">
            <label for="model"><b>Value</b></label>
            <input
              id="txtFieldValue"
              type="text"
              class="form-control form-control-sm"
              v-model="fieldData.value"
              :disabled="$store.state.currentTemplateName === 'global'"
              @change="changeValueEdit"
            >
          </div>
        </div>

        <!-- END VALUE -->

        <div
          v-if="fieldData.model !== undefined && fieldData.model !== null && fieldData.model !== ''"
          class="col-sm-3">
          <div class="form-group">
            <label for="model"><b>No reverse</b></label>

            <br>

            <input
              id="noReverseCheck"
              type="checkbox"
              :checked="fieldData.noReverse"
              @change="fieldData.noReverse === undefined ? fieldData.noReverse = true : fieldData.noReverse = !fieldData.noReverse"
            >
          </div>
        </div>

        <!-- MAX CHARACTER STRING -->

        <div class="col-sm-3" v-if="fieldData.type === 'text'">
          <div class="form-group">
            <label for="model"><b>Max Length</b></label>
            <input
              id="txtFieldValue"
              type="text"
              class="form-control form-control-sm"
              v-model="fieldData.maxCharacter"
              :disabled="$store.state.currentTemplateName === 'global'"
            >
          </div>
        </div>

      </div>

      <hr />

      <localizations ref="localizations" :fieldId="fieldData.id" :currentModel="editorText" :translations="translations"></localizations>

      <hr />

      <div class="row modal-section" id="modalSectionEdit">
        <h2 class="ml-3 w-100">Model</h2>
        <div class="col-sm-3" id="panelModelSearch">
          <!-- <div class="input-group search-group">
            <input type="text" id="modelSearch" class="form-control" placeholder="Search">
            <span class="input-group-addon"><i class="fas fa-search"></i></span>
          </div> -->

          <div class="input-group input-group-sm search-group">
            <input type="text" id="modelSearch" class="form-control" placeholder="Search">
            <div class="input-group-prepend">
              <span class="input-group-text input-group-addon"><i class="fas fa-search"></i></span>
            </div>
          </div>

          <tree-view></tree-view>
        </div>
        <div class="col-sm-6" id="panelModelEdit">
          <h2>Model Editor</h2>
          <textarea v-model="editorText" id="modelEdit" class="form-control form-control-sm" :disabled="$store.state.currentTemplateName === 'global'"></textarea> {{ setModelChange }}
          <h2>Preview</h2>
          <div id="editPreview"></div>
        </div>
        <div class="col-sm-3" id="panelModelFunctions">
          <h2>Functions & Operators</h2>
          <function-toolbox></function-toolbox>
        </div>
      </div>

      <!-- Questionnaire Tags -->

      <hr>

      <div class="row modal-section" id="sectionQuestionnaireTags">
        <div class="col-sm-12">
          <questionnaire-tags
            :fieldData="fieldData"
          />
        </div>
      </div>

      <hr>

      <div class="row modal-section" id="AbGroupWatchersField">
        <div class="col-sm-12">
          <ab-group-watchers
            :isGroup="false"
            :fieldData="fieldData"
          />
        </div>
      </div>

      <hr>
      <br>

      <div class="col-sm-12 text-center">
        <button
          v-if="
            $store.state.currentTemplateName !== 'global' &&
            showResetField
          "
          class="btn btn-primary"
          @click="confirmResetField"
        >
          Reset Field
        </button>
        <button
          v-if="
            $store.state.currentTemplateName !== 'global' &&
            showSendQuestionnaire === null &&
            fieldGroup === 'none'
          "
          class="btn btn-primary"
          @click="sendQuestionnaireField"
        >
          Send to Questionnaire
        </button>
        <button
          v-if="$store.state.currentTemplateName !== 'global'"
          class="btn btn-danger"
          @click="confirmDeleteField"
        >
          Delete Field
        </button>
      </div>

      <div class="col-12" style="margin-bottom: 60px;">
        <div class="float-right">
          <button v-if="$store.state.currentTemplateName !== 'global'" id="btnSave" class="btn btn-success" @click="saveField">Save</button>
          <button v-if="$store.state.currentTemplateName !== 'global'" id="btnSave" class="btn btn-danger " @click="cancelField">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TreeView from '@/components/editor/modal-edit/TreeView'
import FunctionToolbox from '@/components/editor/modal-edit/FunctionToolbox'
import Localizations from '@/components/editor/modal-edit/Localizations'
import QuestionnaireTags from '@/components/questionnaires/QuestionnaireTags'
import AbGroupWatchers from '@/components/questionnaires/ABGroupWatchers'

import AutocompleteModel from '@/components/editor/modal-edit/AutocompleteModel.vue'

export default {
  name: 'modal-edit-field',

  components: {
    TreeView,
    FunctionToolbox,
    Localizations,
    QuestionnaireTags,
    AbGroupWatchers,
    AutocompleteModel
  },

  mounted () {
    let that = this
    this.saveDelete = false

    if (!this.$store.state.widgets.length) {
      const apiUrl = this.$store.state.apiUrl
      this.axios.get(apiUrl + 'widget/list').then(response => {
        this.$store.commit('setWidgets', response.data)
      })
    }
    const apiUrl = this.$store.state.apiUrl
    this.axios.get(apiUrl + 'model/list').then(response => {
      this.$store.commit('setModels', response.data)
    })

    this.$bus.on('saveTriggered', function () {
      if (that.$store.state.currentTemplateName === 'global') that.closeModal()
      else that.saveField()
    })

    this.$bus.on('openFieldMenu', this.setupModal)

    this.$bus.on('getFieldId', function () {
      that.$bus.emit('setFieldId', that.fieldData)
    })

    this.$bus.$on('setCurrentTemplateName', function (templateName) {
      console.log(templateName)
      if (!that.visible) return
      const fieldIndex = that.$store.getters.templateFieldIndex(
        templateName,
        that.fieldId,
        that.$store.state.fileCurrentPage
      )
      if (fieldIndex !== null) {
        that.fieldData = JSON.parse(JSON.stringify(that.$store.state.templates[templateName]['pages'][that.$store.state.fileCurrentPage][fieldIndex]))
        that.editorText = that.fieldData['model']
        setTimeout(function () {
          if (that.$refs.localizations === undefined) return
          if (typeof that.fieldData.translations === 'undefined') that.$refs.localizations.$emit('updateLocalizations', {})
          else that.$refs.localizations.$emit('updateLocalizations', that.fieldData.translations)
        }, 300)
      } else that.closeModal()
    })

    this.$bus.$on('setPageScale', function () {
      that.visible = false
    })

    this.$bus.$on('pageChange', function () {
      that.visible = false
    })

    this.$on('updateTranslations', function (translations) {
      that.fieldData['translations'] = translations
      that.generalSave()
    })

    this.$on('addItem', function (item) {
      that.editorText += ' ' + item
      that.editorText.trim()
    })

    this.$bus.on('closeModal', function () {
      that.closeModal()
    })

    this.$bus.on('confirmFieldDelete', function () {
      that.deleteField()
    })

    this.$bus.on('confirmFieldReset', function () {
      that.resetField()
    })

    document.addEventListener('keyup', function (evt) {
      if (evt.keyCode === 27) that.visible = false
    })
  },

  data () {
    return {
      visible: false,
      validTabIndex: true,
      translations: {},
      saveDelete: false,
      currentFieldGroup: 'none',
      currentCheckboxGroup: 'none',
      fieldGroup: 'none',
      checkboxGroup: 'none',
      isCheckbox: false,

      fieldId: '',
      fieldData: {},

      editorText: '',

      fieldNames: [],
      checkboxNames: [],

      maskTypes: [
        {
          maskType: 'None',
          description: 'No mask applied'
        },
        {
          maskType: 'Date',
          description: '01/15/2018'
        },
        {
          maskType: 'Date (ISO 8601)',
          description: '2018/01/15'
        },
        {
          maskType: 'Phone (US)',
          description: '(123) 456-7890'
        },
        {
          maskType: 'Phone (International)',
          description: '+11 123 4567890'
        },
        {
          maskType: 'EIN',
          description: '12-3456789'
        },
        {
          maskType: 'Alien Number',
          description: '123-456-789'
        },
        {
          maskType: 'Email Address',
          description: 'user@test.com'
        },
        {
          maskType: 'Zip Code',
          description: '12345-1234'
        },
        {
          maskType: 'Social Security Number',
          description: '123-45-7890'
        },
        {
          maskType: 'US Dollars',
          description: '$1,234,567.89'
        }
      ],

      isAutocompleteModel: false,
      autocompleteModelData: null,
      autocompleteModel: '',
      isAutoCompleteClick: false,

      fieldValue: null
    }
  },

  computed: {
    setModelChange: function () {
      this.editorText = this.fieldData.model
    },

    showResetField () {
      const fieldIndex = this.$store.getters.templateFieldIndex('global', this.fieldData.id, this.$store.state.fileCurrentPage)
      return fieldIndex !== null
    },

    choiceData: {
      get: function () {
        if (typeof this.fieldData.choiceData === 'undefined') this.fieldData['choiceData'] = []
        // choicedata damage ----> Props Expected Array
        if (this.fieldData.choiceData[0] === '[') return
        return this.fieldData.choiceData.join(',')
      },

      set: function (newVal) {
        if (!newVal.length) this.fieldData.choiceData = []
        else this.fieldData.choiceData = newVal.split('|')
      }
    },

    showSendQuestionnaire () {
      const questionnaireField = this.$store.getters.searchQuestionnaire(this.fieldData.id)
      return questionnaireField
    }
  },

  methods: {
    setAutocompleteModel () {
      if (this.fieldData.model.length <= 6) return

      this.isAutocompleteModel = true

      this.autocompleteModelData = {}

      this.autocompleteModelData.top = document.getElementById('txtFieldModel').offsetTop
      this.autocompleteModelData.left = document.getElementById('txtFieldModel').offsetLeft
      this.autocompleteModel = this.fieldData.model
      this.autocompleteModelData.fieldId = this.fieldData.id
      this.autocompleteModelData.type = this.fieldData.type
      this.autocompleteModelData.page = this.fieldData.fieldPage
    },

    setOfficialModel (payload) {
      this.fieldData.model = payload.model
      this.isAutoCompleteClick = true
    },

    hideAutocompleteModel () {
      setTimeout(() => {
        this.isAutocompleteModel = false
      }, 500)
    },

    changeModelEdit () {
      if (this.fieldData.value !== '' && this.fieldData.model !== '') {
        this.fieldData.model = ''

        alert('You can not have model and value at the same time.')

        return
      }

      this.$store.commit('setOfficialModel', {
        model: this.fieldData.model,
        fieldId: this.fieldData.id,
        page: this.$store.state.fileCurrentPage
      })

      let updatePdfField = this.fieldData.id.replace(/]_/g, '].')

      const autofillDetail = {
        autofillId: this.$store.state.autofillId,
        templateId: this.$store.state.templates[this.$store.state.currentTemplateName]['_id'],
        pdfField: this.fieldData.id,
        model: this.fieldData.model,
        value: '',
        fieldType: this.fieldData.type,
        createdAt: new Date(),
        updatedAt: new Date()
      }

      this.$bus.emit('saveAutofillDetail', {
        modelValue: this.fieldData.model,
        updatePdfField,
        elId: this.fieldData.id,
        autofillDetail,
        model: true
      })
    },

    changeValueEdit () {
      if (this.fieldData.model !== '' && this.fieldData.value !== '') {
        this.fieldData.value = ''

        alert('You can not have model and value at the same time.')

        return
      }

      let fieldId = this.fieldData.id

      fieldId = fieldId.replace(/]_/g, '].')

      if (this.$store.state.autofillDetails.map(a => a.pdfField).indexOf(fieldId) === -1) {
        const autofillDetail = {
          autofillId: this.$store.state.autofillId,
          templateId: this.$store.state.templates[this.$store.state.currentTemplateName]._id,
          value: this.fieldData.value,
          pdfField: fieldId,
          fieldType: this.fieldData.type === 'text' ? '1' : this.fieldData.type === 'combobox' ? '2' : this.fieldData.type === 'checkbox' ? '3' : '4',
          model: this.fieldData.model,
          createdAt: new Date(),
          updatedAt: new Date()
        }

        this.$bus.emit('saveAutofillDetail', {
          modelValue: this.fieldData.model,
          updatePdfField: autofillDetail.pdfField,
          autofillDetail,
          value: true
        })
      } else {
        let autofillDetail = JSON.parse(JSON.stringify(
          this.$store.state.autofillDetails[this.$store.state.autofillDetails.map(a => a.pdfField).indexOf(fieldId)]
        ))

        autofillDetail.value = this.fieldData.value

        this.$bus.emit('saveAutofillDetail', {
          modelValue: this.fieldData.model,
          updatePdfField: autofillDetail.pdfField,
          autofillDetail,
          value: true
        })
      }
    },

    cancelField () {
      this.visible = false
    },

    setupModal (fieldData) {
      this.resetModal()
      this.visible = true
      this.fieldId = fieldData.id
      let oldFieldId = this.fieldId

      this.fieldValue = this.$store.state.autofillDetails.filter(a => a.pdfField === oldFieldId.replace(/]_/g, '].'))[0] !== undefined ? this.$store.state.autofillDetails.filter(a => a.pdfField === oldFieldId.replace(/]_/g, '].'))[0].value : ''

      let fData = null

      fData = JSON.parse(JSON.stringify(this.$store.getters.getTemplateData(this.fieldId)))
      fData.value = this.fieldValue

      if (fData === null) return

      fData.type = fData.type.toLowerCase()

      if (fData.type === 'button') fData.type = 'checkbox'

      // SET NO REVERSE

      if (
        fData.model.indexOf('#') !== -1 ||
        fData.model.indexOf('(') !== -1 ||
        fData.model.indexOf(')') !== -1 ||
        fData.model.indexOf('+') !== -1 ||
        fData.model.indexOf(',') !== -1 ||
        fData.model.indexOf('attorney') !== -1 ||
        fData.model.indexOf('verbose') !== -1
      ) fData.noReverse = true

      // END SET NO REVERSE

      this.compareInlineLabel(fData)

      if (fData.type === 'checkbox') this.isCheckbox = true
      else this.isCheckbox = false

      this.fieldData = fData
      if (typeof fData.prefix === 'undefined') fData['prefix'] = ''
      this.editorText = fData['model']
      if (typeof fData.translations === 'undefined') this.translations = {}
      else this.translations = fData.translations
      this.fieldData = fData
      this.fieldNames = this.$store.getters.groupFieldNames()
      this.checkboxNames = this.$store.getters.chGroupCheckboxNames()

      this.fieldGroup = this.$store.getters.fieldGroup(this.fieldId)
      if (this.fieldGroup === null || this.changeGroup === undefined) this.fieldGroup = 'none'
      this.currentFieldGroup = this.fieldGroup

      this.checkboxGroup = this.$store.getters.checkboxGroup(this.fieldId)
      if (this.checkboxGroup === null || this.changeGroup === undefined) this.checkboxGroup = 'none'
      this.currentCheckboxGroup = this.checkboxGroup
    },

    compareInlineLabel (formData) {
      if (
        formData.translations === undefined ||
        this.$store.state.questionnaires.default === undefined
      ) return

      Object.keys(this.$store.state.questionnaires.default.data).forEach(fieldKey => {
        if (this.$store.state.questionnaires.default.data[fieldKey].fieldName === formData.id) {
          let fieldQ = this.$store.state.questionnaires.default.data[fieldKey]

          if ((formData.translations.en.text !== fieldQ.desc) || (formData.translations.en.label !== fieldQ.title)) {
            formData.translations.en.text = fieldQ.desc
            formData.translations.en.label = fieldQ.title

            this.$store.commit('setTemplateFieldPage', formData)

            this.$store.dispatch('saveTemplate')
          }
        }

        if (this.$store.state.questionnaires.default.data[fieldKey].type === 'checkbox-group') {
          let fieldGroup = this.$store.state.questionnaires.default.data[fieldKey]

          Object.keys(fieldGroup.checkboxes).forEach(chKey => {
            if (chKey === formData.id) {
              let fieldQ = fieldGroup.checkboxes[chKey]

              if ((formData.translations.en.text !== fieldQ.translations.en.text) || (formData.translations.en.label !== fieldQ.translations.en.label)) {
                formData.translations.en.text = fieldQ.translations.en.text
                formData.translations.en.label = fieldQ.translations.en.label

                this.$store.commit('setTemplateFieldPage', formData)

                this.$store.dispatch('saveTemplate')
              }
            }
          })
        }
      })
    },

    resetModal () {
      this.translations = {}
      this.fieldId = ''
      this.fieldData = {}
      this.editorText = ''
    },

    changeGroup (e) {
      if (e.target.value === this.currentFieldGroup) return

      if (this.currentFieldGroup !== 'none') {
        this.$store.commit('removeFieldFromGroup', {
          index: this.currentFieldGroup,
          fieldId: this.fieldId
        })
      }

      if (e.target.value !== 'none') {
        let dataField = this.$store.getters.getTemplateData(this.fieldId)

        this.$store.commit('addFieldToGroup', {
          index: e.target.value,
          fieldId: this.fieldId,
          dataField: dataField
        })
      }

      this.currentFieldGroup = e.target.value

      this.$store.dispatch('saveTemplate')
      this.$bus.emit('reloadQuestionnaire')
      this.fieldNames = this.$store.getters.groupFieldNames()
    },

    createFieldGroup () {
      let isWidget = this.$store.getters.getIfExistFieldOnWidget(this.fieldData.name)
      if (isWidget) {
        window.swal({
          title: 'You chose a field belong to a widget',
          text: 'Fields belong to widgets do not add to Field-Group',
          icon: 'warning',
          dangerMode: true
        })
      }
      if (isWidget) return

      let that = this
      this.$store.commit('deleteExistOnFieldGroups', this.fieldId)
      let newGroupId = Math.random().toString(36).split('.')[1]
      let newFields = {}

      let dataField = this.$store.getters.getTemplateData(this.fieldId)

      newFields[this.fieldId] = dataField
      let newGroup = {
        name: 'New Group - ' + newGroupId,
        fieldAdd: that.fieldData.id,
        title: that.fieldData.translations['en'].label,
        desc: that.fieldData.translations['en'].text,
        checked: [],
        fields: newFields,
        tabOrder: that.fieldData.tabOrder,
        page: that.fieldData.fieldPage,
        prefix: that.fieldData.prefix
      }

      this.$store.dispatch('createFieldGroup', {
        index: newGroupId,
        data: newGroup
      })
      this.fieldNames = this.$store.getters.groupFieldNames()
      let newId = this.$store.getters.fieldGroup(this.fieldId)
      this.fieldGroup = newId
      this.currentFieldGroup = newId
      this.$bus.emit('setOnlyFieldGroup', newGroupId)
      this.$store.dispatch('saveTemplate')
    },

    changeCheckboxGroup (e) {
      if (e.target.value === this.currentCheckboxGroup) return

      if (this.currentCheckboxGroup !== 'none') {
        this.$store.commit('removeCheckboxFromGroup', {
          index: this.currentCheckboxGroup,
          fieldId: this.fieldId
        })
      }

      if (e.target.value !== 'none') {
        let dataField = this.$store.getters.getTemplateData(this.fieldId)

        this.$store.commit('addCheckboxToGroup', {
          index: e.target.value,
          fieldId: this.fieldId,
          dataField: dataField
        })
      }

      this.currentCheckboxGroup = e.target.value

      this.$store.dispatch('saveTemplate')
      this.$bus.emit('reloadQuestionnaire')
      this.checkboxNames = this.$store.getters.chGroupCheckboxNames()
    },

    createCheckboxGroup () {
      let that = this
      this.$store.commit('deleteExistOnCheckboxGroups', this.fieldId)
      let newGroupId = Math.random().toString(36).split('.')[1]
      let newFields = {}

      let dataField = this.$store.getters.getTemplateData(this.fieldId)

      newFields[this.fieldId] = dataField
      let newGroup = {
        name: 'New Group - ' + newGroupId,
        fieldAdd: that.fieldData.id,
        title: that.fieldData.translations['en'].label,
        desc: that.fieldData.translations['en'].text,
        checked: [],
        checkboxes: newFields,
        tabOrder: that.fieldData.tabOrder,
        page: that.fieldData.fieldPage,
        prefix: that.fieldData.prefix
      }

      this.$store.dispatch('createCheckboxGroup', {
        index: newGroupId,
        data: newGroup
      })

      this.checkboxNames = this.$store.getters.chGroupCheckboxNames()
      let newId = this.$store.getters.checkboxGroup(this.fieldId)
      this.checkboxGroup = newId
      this.currentCheckboxGroup = newId
      this.$store.dispatch('saveTemplate')
    },

    resetField () {
      const globalTemplateField = this.$store.getters.templateField('global', this.fieldData.id, this.$store.state.fileCurrentPage)
      const currentFieldIndex = this.$store.getters.currentTemplateFieldIndex(this.fieldData.id, this.$store.state.fileCurrentPage)

      let currentPage = this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][this.$store.state.fileCurrentPage]
      currentPage[currentFieldIndex] = globalTemplateField

      this.$store.dispatch('saveTemplate')

      this.$store.commit('setCurrentTemplateName', 'global')
      this.$store.commit('setCurrentTemplateName', 'default')
      this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire')
    },

    deleteField () {
      const fieldIndex = this.$store.getters.currentTemplateFieldIndex(this.fieldData.id, this.$store.state.fileCurrentPage)
      this.$store.commit('deleteField', fieldIndex)
      this.$store.commit('setCurrentTemplateName', 'global')
      this.$store.commit('setCurrentTemplateName', 'default')
      this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire')
      this.saveDelete = true
      this.saveField()
    },

    confirmDeleteField () {
      this.$bus.emit('showDialog', {
        title: 'Delete Field?',
        desc: 'You are about to delete ' + this.fieldData.name + ' from the ' + this.$store.state.currentTemplateName + ' template. Do you want to continue?',
        confirmAction: 'confirmFieldDelete'
      })
    },

    confirmResetField () {
      this.$bus.emit('showDialog', {
        title: 'Reset Field?',
        desc: 'You are about to reset ' + this.fieldData.name + ' with the data from the global template. Do you want to continue?',
        confirmAction: 'confirmFieldReset'
      })
    },

    sendQuestionnaireField () {
      window.swal({
        title: 'Generate Question?',
        text: 'You are about to generate questionnaire questions using the form fields. This is a new questionnaire. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((generate) => {
        if (generate) {
          let dataQuestionnaires = this.$store.getters.addFieldQuestionnaire(this.fieldData)
          this.$store.commit('setQuestionnaires', dataQuestionnaires)
          this.$store.dispatch('saveTemplate')
          this.$bus.emit('updateQuestionnaire')
          this.$bus.emit('reloadQuestionnaire')
          this.visible = false
        }
      })
    },

    closeModal () {
      if (
        this.fieldData.model !== undefined &&
        this.fieldData.model !== null &&
        this.fieldData.model !== '' &&
        this.fieldData.value !== undefined &&
        this.fieldData.value !== null &&
        this.fieldData.value !== ''
      ) {
        document.getElementById('txtFieldValue').focus()

        alert('You can not have model and value at the same time.')

        return
      }

      this.generalSave()
      this.visible = false
    },

    generalSave (deletedField = false) {
      if (
        this.fieldData.model !== undefined &&
        this.fieldData.model !== null &&
        this.fieldData.model !== '' &&
        this.fieldData.value !== undefined &&
        this.fieldData.value !== null &&
        this.fieldData.value !== ''
      ) {
        document.getElementById('txtFieldValue').focus()

        alert('You can not have model and value at the same time.')

        return
      }

      this.fieldData['model'] = this.editorText
      this.fieldData['id'] = this.fieldId

      const fieldIndex = this.$store.getters.templateFieldIndex(
        this.$store.state.currentTemplateName,
        this.fieldId,
        this.$store.state.fileCurrentPage
      )
      let currentPage = this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][this.$store.state.fileCurrentPage]
      this.fieldData.tabOrder = Number(this.fieldData.tabOrder)
      currentPage[fieldIndex] = this.fieldData

      // NUCLEAR

      this.$store.commit('setTemplateField', {
        templateName: this.$store.state.currentTemplateName,
        page: this.$store.state.fileCurrentPage,
        fieldId: this.fieldId,
        data: this.fieldData
      })

      const groupId = this.$store.getters.fieldGroup(this.fieldId)
      if (groupId !== null) {
        let fieldLabel = this.fieldId
        let fieldDesc = ''
        if (typeof this.fieldData.translations !== 'undefined') {
          if (typeof this.fieldData.translations[this.$store.state.currentLocale] !== 'undefined') {
            fieldLabel = this.fieldData.translations['en']['label']
            fieldDesc = this.fieldData.translations['en']['text']
          }
        }
        this.$store.commit('editFieldGroupFieldLabel', {
          index: groupId,
          fieldId: this.fieldId,
          fieldLabel: fieldLabel,
          fieldDesc: fieldDesc
        })
      }

      this.$bus.emit('addNotification', {
        title: (this.saveDelete ? 'Field Deleted' : 'Field Updated'),
        body: 'The field was ' + (this.saveDelete ? 'deleted' : 'updated') + ' successfully',
        type: 'success'
      })

      if (this.saveDelete) this.$store.commit('deleteQuestionnaireField', this.fieldId)
      else {
        this.$store.commit('updateQuestionnaireField', {
          name: this.fieldId,
          dataField: JSON.parse(JSON.stringify(this.fieldData))
        })
      }

      this.$bus.emit('reloadQuestionnaire')
      this.$bus.emit('hidePageFields')

      this.$store.dispatch('saveTemplate')

      // END NUCLEAR
    },

    saveField (deletedField = false) {
      this.$store.commit('updatePrefixQuestionnaire', {
        fieldName: this.fieldData.name,
        prefix: this.fieldData.prefix
      })
      this.$bus.emit('hidePageFields')
      this.closeModal()
    },

    validateTabIndex () {
      if (Number(this.fieldData.tabOrder) === Number(this.$store.getters.templateTabOrder(this.fieldId))) {
        this.validTabIndex = true
        return
      }
      this.validTabIndex = !this.$store.getters.tabOrderExists(this.fieldData.tabOrder)
    },

    setModelValue (model) {
      this.fieldData.model = model
    }
  },

  beforeDestroy () {
    this.$bus.$off('saveTriggered')
    this.$bus.$off('openFieldMenu')
    this.$bus.$off('getFieldId')
    this.$bus.$off('setCurrentTemplateName')
    this.$bus.$off('setPageScale')
    this.$bus.$off('pageChange')
    this.$off('updateTranslations')
    this.$off('addItem')
    this.$bus.$off('closeModal')
    this.$bus.$off('confirmFieldDelete')
    this.$bus.$off('confirmFieldReset')
  }
}
</script>

<style lang="scss" scoped>
  .invalid {
    background-color: #F009;
  }

  hr {
    border-color: #777;
    margin: 10px 20px 10px 20px;
  }

  .modalHeader {
    background-color: #2d5f8b;
    color: white;
    font-size: 18px;
    padding: 5px 10px 5px 10px;

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }
  }

  .globalAlert {
    background-color: #ff7480;
    color: #000;
    text-align: center;
    font-size: 18px;
  }

  #modalEditField {
    user-select: none;
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    height: 80%;
    border: 1px solid black;
    background-color: #FFF;
    overflow: hidden;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    z-index: 20;
  }

  .modalBody {
    overflow-x: hidden;
    overflow-y: scroll;
    height: 95%;
  }

  .modal-section {
    padding: 20px;
  }

  #modalSectionEdit {
    h1 {
      margin-top: 0;
    }
  }

  .search-group {
    margin-bottom: 10px;
  }

  #modelEdit {
    width: 100%;
    resize: vertical;
  }

  #panelModelSearch {
    #searchResults {
      margin-top: 5px;
      border: 1px solid black;
      width: 100%;
      height: 300px;
    }
  }

  #panelModelEdit {
    h2 {
      margin: 0 0 10px 0;
    }

    #editPreview {
      border: 1px solid black;
      width: 100%;
      height: 50px;
    }
  }

  #panelModelFunctions {
    h2 {
      margin: 0 0 10px 0;
    }
  }

  #btnDisabled {
    margin-right: 25px;
    margin-bottom: 15px;
    font-size: 18px;
  }

  .disable-save {
    margin-right: 10px;
    font-weight: bold;
  }

  .btnNewGroup {
    display: inline-block;
    margin-top: -10px;
    margin-left: 10px;
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/modal-edit/ModalEditField.vue